import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { derived, writable } from "svelte/store";
import { adminFeaturePricing } from "../../../api/admin";

export const confirmedStore = writable(false);

export const additionsStore = writable({});

export const modulePricingApiStore = SwApiStore({
  get: (...args) => adminFeaturePricing({ feature: "modules" }, ...args),
  init: () => ({ modules: {} }),
});

export const totalPriceStore = derived(
  [additionsStore, modulePricingApiStore],
  ([$additionsStore, $modulePricingApiStore]) =>
    Object.entries($additionsStore)
      .map(
        ([licenseKind, count]) =>
          ($modulePricingApiStore?.modules[licenseKind] || 0) * count,
      )
      .reduce((a, b) => a + b, 0),
);

export const priceSuffixStore = derived(
  modulePricingApiStore,
  ($modulePricingApiStore) =>
    ({
      gbp: " (£)",
      usd: " ($)",
    })[$modulePricingApiStore.currency] || "",
);
